<ng-container *transloco="let t; read: TRANSLATION_SCOPE">
  <div class="col card-shadow mb-3" *ngIf="defaultValue | as : Room as room">
    <rx-applications-clientsite-checkout-room-header [room]="room" [index]="index" />
    <form class="col" [formGroup]="(form.get(formSectionName) | as : FormArray).at(index) | as : FormGroup">
      <rx-applications-clientsite-checkout-guests
        [formSectionName]="RoomsFormTemplates.GUESTS"
        [numberOfGuests]="room.adults"
      />
    </form>
  </div>
</ng-container>
